<template>
  <section class="section">
    <div class="section__content quote">
      <Image :source="content.image" class="--quote --round-borders" v-reveal />
      <div>
        <SectionHeader v-if="content.header" :text="content.header" v-reveal="{ delay: 150 }" />
        <p class="title" v-reveal="{ delay: 200 }">{{ content.quote }}</p>
        <div :class="['quote__author', color(content.color)]" v-reveal="{ delay: 250 }">
          <img src="@/assets/symbols/chat.svg" alt="" class="quote__author-icon" />
          <div>
            <p class="small-title quote__author-title">{{ content.author }}</p>
            <p>{{ content.job }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Image } from '@/components/global'
import { SectionHeader } from '@/components/small'
import { color } from '@/helpers'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'QuoteSection',
  mixins: [DefaultSectionProps],
  components: { Image, SectionHeader },
  methods: { color },
}
</script>
